var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Typography } from '@mui/material';
import { SessionManager } from '@madbox/react_session_manager';
export default function DefaultNotLoggedView() {
    return (_jsxs(Typography, { children: ["You are not logged in", ' ', _jsx(Button, __assign({ variant: "text", onClick: function () {
                    SessionManager.logout(false);
                    window.location.reload();
                } }, { children: "Retry" }), void 0)] }, void 0));
}
